import { useMutation } from '@tanstack/react-query';
import { LoginPayloadData } from '../../model/auth';
import { AuthRepository } from '../instances/auth';

/** Login passo 1: senha no Firebase + dispara o 2FA. */
export const useAuthMutation = () => {
  return useMutation({
    mutationFn: async (data: LoginPayloadData) => {
      await AuthRepository.login(data.email, data.password);
    },
  });
};

/** Login passo 2: valida o código 2FA → sessão. */
export const use2FaMutation = () => {
  return useMutation({
    mutationFn: async (code: string) => {
      const [err, resp] = await AuthRepository.verifyTwoFactor(code);
      if (err) {
        throw err;
      }
      return resp;
    },
  });
};

/** Esqueci minha senha → email de redefinição do Firebase. */
export const useForgotPasswordMutation = () => {
  return useMutation({
    mutationFn: async (email: string) => {
      await AuthRepository.forgotPassword(email);
    },
  });
};
